export type AppEnvironment = 'LOCAL' | 'STAGING' | 'REVIEW' | 'PREVIEW' | 'PRODUCTION';

export function getEnvironment(): AppEnvironment {
  const apiUrl: string = import.meta.env.VITE_KORINT_API_URL ?? '';

  if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) return 'LOCAL';
  if (apiUrl.includes('api.staging')) return 'STAGING';
  if (/rv-\d+\.api\.develop\.korint\.io/.test(apiUrl)) return 'REVIEW';
  if (/api-pv\d+\.preview\.develop\.korint\.io/.test(apiUrl)) return 'PREVIEW';

  return 'PRODUCTION';
}
